import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-exg-form-submit',
  templateUrl: './exg-form-submit.component.html',
  styles: [
  ]
})
export class ExgFormSubmitComponent implements OnInit, AfterViewInit {

  @Input() formIdent = 'formID';
  @Input() submitText = 'Abschließen';
  @Input() formValues: string | undefined;

  _forceDisable = false;
  get forceDisable(): boolean {
    return this._forceDisable;
  }
  @Input() set forceDisable(value: boolean) {
    this._forceDisable = value;
    if (!this.isViewInit) {
      setTimeout(() => {
        this.cleanUpValues();
      }, 50);
    }
  }

  _htmlForm: string | undefined;
  get htmlForm(): string | undefined {
    return this._htmlForm;
  }
  @Input() set htmlForm(value: string | undefined) {
    this._htmlForm = value;
    if (this.htmlForm) {
      this.sanitizedForm = this.getSafeHtml(this.htmlForm);
    }
    if (!this.isViewInit) {
      setTimeout(() => {
        this.cleanUpValues();
      }, 50);
    }
  }

  @Output() formSubmit = new EventEmitter<any>();

  sanitizedForm: SafeHtml = '';
  sanitizedValues: any;

  isViewInit = true;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    if (this.formValues) {
      this.sanitizedValues = JSON.parse(this.formValues);
    }
    this.isViewInit = false;
  }

  ngAfterViewInit(): void {
    this.cleanUpValues();
  }

  cleanUpValues(): void {
    if (this.sanitizedForm) {
      const elements = (document.forms as any)[this.formIdent as any].getElementsByTagName('input');
      for (const element of elements) {
        if (this.sanitizedValues && this.sanitizedValues[element.name]) {
          element.value = this.sanitizedValues[element.name];
        }
        element.disabled = this.forceDisable;
      }
    }
  }

  submitForm(event: Event): void{
    event.preventDefault();
    event.stopPropagation();
    const element = document.getElementById(this.formIdent);
    const data = new FormData(element as HTMLFormElement);
    // @ts-ignore
    const results = Object.fromEntries(data.entries());
    this.formSubmit.emit(results);
  }

  getSafeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}
